exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide[data-v-7480b773]{position:relative;overflow:hidden}@media screen and (max-width:450px){.slide-image.square[data-v-7480b773]{height:0;padding-bottom:100%}}.slide-image[data-v-7480b773]{width:100%;height:100%;position:absolute;background-size:cover;background-repeat:no-repeat;background-position:50%}.slide-fade-enter-active[data-v-7480b773],.slide-fade-leave-active[data-v-7480b773]{-webkit-transition:opacity .3s;transition:opacity .3s}.slide-fade-enter[data-v-7480b773],.slide-fade-leave-to[data-v-7480b773]{opacity:0}", ""]);

// exports
